import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import Login from '../../../modules/Auth/Login';
import User from '../../../modules/User/User';
import Sensor from '../../../modules/Sensor/Sensor';
import RoutesConstants from './routes.constants';
import LoginLayoutRoute from './LoginLayoutRoute';
import LayoutRoute from './LayoutRoute';
import { withRouter } from 'react-router-dom';
import Logout from '../../../modules/Auth/Logout';
import SensorData from '../../../modules/SensorData/SensorData';
import SensorDataLineChart from '../../../modules/SensorLineChart/SensorDataLineChart';
import Download from '../../../modules/Download/Download';
import IAQSensorData from '../../../modules/IAQSensorData/IAQSensorData';
import IAQSensors from '../../../modules/iaq-sensor/iaq-sensor';
import IAQSensorDataLineChart from '../../../modules/IAQSensorLineChart/IAQSensorDataLineChart';
import IAQRealTimeView from '../../../modules/IAQRealTimeView/IAQRealTimeView';

const Routes = (props: any) => {
    return (
        <React.Fragment>
            <Switch>
                <LoginLayoutRoute path={RoutesConstants.Login} component={Login} />
                <LayoutRoute path={RoutesConstants.User} component={User} />
                <LayoutRoute path={RoutesConstants.Sensor} component={Sensor} />
                <LayoutRoute path={RoutesConstants.SensorData} component={SensorData} />
                <LayoutRoute path={RoutesConstants.SensorDataChart} component={SensorDataLineChart} />
                <LayoutRoute path={RoutesConstants.Download} component={Download} />
                <LayoutRoute path={RoutesConstants.IAQSensorData} component={IAQSensorData} />
                <LayoutRoute path={RoutesConstants.IAQSensorDataChart} component={IAQSensorDataLineChart} />
                <LayoutRoute path={RoutesConstants.IAQRealTimeView} component={IAQRealTimeView} />
                <LayoutRoute path={RoutesConstants.Logout} component={Logout} />
                <LayoutRoute path={RoutesConstants.IAQSensor} component={IAQSensors} />
                <Redirect to={RoutesConstants.Sensor} />
            </Switch>
        </React.Fragment>
    );
};

export default withRouter(Routes);